export const baseTaxRates = {
  koerperschaftsteuer: 0.15,
  solidaritaetszuschlag: 0.055,
  kstPlusSoli: 0.15825,
  abgeltungsteuer: 0.25,
  abgeltungsteuerPlusSoli: 0.26375,
  kirchensteuer: { bayernBW: 0.08, other: 0.09 },
};

export const einkommensteuerBrackets2026 = [
  { from: 0, to: 12348, rate: 0, method: 'exempt' },
  { from: 12349, to: 17799, rateFrom: 0.14, rateTo: 0.2397, method: 'progressive_formula' },
  { from: 17800, to: 69878, rateFrom: 0.2397, rateTo: 0.42, method: 'progressive_formula' },
  { from: 69879, to: 277825, rate: 0.42, method: 'flat' },
  { from: 277826, to: Infinity, rate: 0.45, method: 'flat' },
];

export const gewerbesteuerData = {
  steuermesszahl: 0.035,
  minimumHebesatz: 200,
  cities: {
    berlin: { hebesatz: 410, gewStRate: 0.1435, totalCorpRate: 0.30175 },
    munich: { hebesatz: 490, gewStRate: 0.1715, totalCorpRate: 0.32975 },
    hamburg: { hebesatz: 470, gewStRate: 0.1645, totalCorpRate: 0.32275 },
    frankfurt: { hebesatz: 460, gewStRate: 0.161, totalCorpRate: 0.31925 },
    duesseldorf: { hebesatz: 440, gewStRate: 0.154, totalCorpRate: 0.31225 },
    cologne: { hebesatz: 475, gewStRate: 0.16625, totalCorpRate: 0.3245 },
    stuttgart: { hebesatz: 420, gewStRate: 0.147, totalCorpRate: 0.30525 },
    leipzig: { hebesatz: 460, gewStRate: 0.161, totalCorpRate: 0.31925 },
    nuremberg: { hebesatz: 447, gewStRate: 0.15645, totalCorpRate: 0.3147 },
    hannover: { hebesatz: 480, gewStRate: 0.168, totalCorpRate: 0.32625 },
    bremen: { hebesatz: 460, gewStRate: 0.161, totalCorpRate: 0.31925 },
    dresden: { hebesatz: 450, gewStRate: 0.1575, totalCorpRate: 0.31575 },
    dortmund: { hebesatz: 485, gewStRate: 0.16975, totalCorpRate: 0.328 },
    essen: { hebesatz: 480, gewStRate: 0.168, totalCorpRate: 0.32625 },
    augsburg: { hebesatz: 435, gewStRate: 0.15225, totalCorpRate: 0.3105 },
    freiburg: { hebesatz: 430, gewStRate: 0.1505, totalCorpRate: 0.30875 },
    mainz: { hebesatz: 440, gewStRate: 0.154, totalCorpRate: 0.31225 },
    bonn: { hebesatz: 530, gewStRate: 0.1855, totalCorpRate: 0.34375 },
    karlsruhe: { hebesatz: 430, gewStRate: 0.1505, totalCorpRate: 0.30875 },
    rostock: { hebesatz: 465, gewStRate: 0.16275, totalCorpRate: 0.321 },
    erfurt: { hebesatz: 450, gewStRate: 0.1575, totalCorpRate: 0.31575 },
    darmstadt: { hebesatz: 430, gewStRate: 0.1505, totalCorpRate: 0.30875 },
    heidelberg: { hebesatz: 400, gewStRate: 0.14, totalCorpRate: 0.29825 },
    muenster: { hebesatz: 460, gewStRate: 0.161, totalCorpRate: 0.31925 },
  },
};

export const entityTypes = {
  private: {
    id: 'private',
    nameDE: 'Privatverm\u00f6gen',
    nameEN: 'Private Ownership',
    gewerbesteuer: false,
    spekulationsfrist: true,
    spekulationsfristYears: 10,
    lossOffsetAgainstOtherIncome: true,
  },
  gmbh: {
    id: 'gmbh',
    nameDE: 'GmbH',
    nameEN: 'Limited Liability Company (GmbH)',
    gewerbesteuer: true,
    spekulationsfrist: false,
    lossOffsetAgainstOtherIncome: false,
  },
  immo_gmbh: {
    id: 'immo_gmbh',
    nameDE: 'Immobilien-GmbH (erw. K\u00fcrzung)',
    nameEN: 'Real Estate GmbH (Extended Reduction)',
    gewerbesteuer: false,
    effectiveRate: 0.15825,
    spekulationsfrist: false,
    lossOffsetAgainstOtherIncome: false,
  },
  gmbh_co_kg: {
    id: 'gmbh_co_kg',
    nameDE: 'GmbH & Co. KG',
    nameEN: 'Asset-Managing Limited Partnership',
    gewerbesteuer: false,
    spekulationsfrist: true,
    spekulationsfristYears: 10,
    lossOffsetAgainstOtherIncome: true,
  },
  stiftung: {
    id: 'stiftung',
    nameDE: 'Familienstiftung',
    nameEN: 'Family Foundation',
    gewerbesteuer: false,
    effectiveRate: 0.15825,
    spekulationsfrist: true,
    spekulationsfristYears: 10,
    lossOffsetAgainstOtherIncome: false,
  },
};
